var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 4.16602C16.6666 5.54673 13.6818 6.66602 9.99992 6.66602C6.31802 6.66602 3.33325 5.54673 3.33325 4.16602M16.6666 4.16602C16.6666 2.7853 13.6818 1.66602 9.99992 1.66602C6.31802 1.66602 3.33325 2.7853 3.33325 4.16602M16.6666 4.16602V15.8327C16.6666 17.2134 13.6818 18.3327 9.99992 18.3327C6.31802 18.3327 3.33325 17.2134 3.33325 15.8327V4.16602M16.6666 8.05485C16.6666 9.43556 13.6818 10.5548 9.99992 10.5548C6.31802 10.5548 3.33325 9.43556 3.33325 8.05485M16.6666 11.941C16.6666 13.3217 13.6818 14.441 9.99992 14.441C6.31802 14.441 3.33325 13.3217 3.33325 11.941",
    stroke: "#EBEBF5",
    strokeOpacity: 0.64,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.c00d2c66a5a52e9c32153ae4ed458b59.svg";
export { ForwardRef as ReactComponent };